/**
 * @see https://github.com/scurker/currency.js/
 */

import currency from 'currency.js';

export default currency;
